import { forwardRef } from 'react';
import { IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  handleClick: () => void;
}

export const GeneralProductLandingButton = forwardRef<HTMLDivElement, Props>(({ handleClick }, ref) => {
  return (
    <Container ref={ref} onClick={handleClick}>
      일반배송으로 구매하기 <IconArrowRightBold v3Color='gray700' size={20} />
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  font-weight: 600;
  font-size: 13px;
  color: ${vars.v3Color.gray700};
  border-top: 1px solid ${vars.v3Color.gray100};
  background: ${vars.v3Color.gray50};
  cursor: pointer;
`;
